"use strict";
exports.__esModule = true;
exports.CHARGE_TYPE_LABEL = void 0;
exports.CHARGE_TYPE_LABEL = {
    professional: 'PRO',
    technical: 'TECH',
    'pro-tech': 'PRO/TECH',
    SHARED_CODES: 'SHARED'
};
//# sourceMappingURL=invoice-meta-info.js.map